<template>
	<div v-html="renderedMarkdown"></div >
</template>

<script>
import markdownIt from 'markdown-it';
const md = markdownIt()
export default {
  props: {
    model: String
  },
  computed: {
    renderedMarkdown() {
      return md.render(this.model)
    }
  }
}
</script>

<style>

</style>
